import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const customerServiceProductsRoute: InvariantJiraRoute = {
	name: 'customer-service-products',
	path: '/jira/customer-service/products',
	exact: true,
};
